import React, {Fragment, useRef} from 'react';
import PropTypes from 'prop-types';
import {CloudArrowDownIcon} from '@heroicons/react/24/outline';
import PaginationNew from '@/components/pagination-new/Pagination';
import PaginationInformation from '@/components/pagination-new/PaginationInformation';
import useScrollToTop from '@/hooks/useScrollToTop';
import Results from './Results';
import View from '@/pages/_components/View';

Partners.propTypes = {
  result: PropTypes.shape({
    meta: PropTypes.shape({
      totalCount: PropTypes.number
    })
  }),
  pageSize: PropTypes.number,
  row: PropTypes.func,
  csvQuery: PropTypes.func,
  filters: PropTypes.node
};

export default function Partners(props) {
  const {
    result,
    pageSize,
    row,
    csvQuery,
    filters
  } = props;

  const node = useRef();
  const scrollToTop = useScrollToTop();

  return (
    <>
      <div ref={node} className="flex items-center justify-between">
        <PaginationInformation
          pageSize={pageSize}
          totalCount={result.meta?.totalCount}
        />
        {filters && (
          <div className="flex flex-wrap gap-4 justify-between items-end">
            {filters}
          </div>
        )}
        {csvQuery && result.meta?.totalCount > 0 && (
          <View
            icon={CloudArrowDownIcon}
            onClick={csvQuery}
          >
            Download results as CSV
          </View>
        )}
      </div>

      <Results
        result={result}
        row={row}
      />
      <div className="flex items-center justify-between">
        <PaginationInformation
          pageSize={pageSize}
          totalCount={result.meta?.totalCount}
        />
        <PaginationNew
          pageSize={pageSize}
          totalCount={result.meta?.totalCount}
          onNavigate={() => scrollToTop(node)}
        />
      </div>
    </>
  );
}
